import { useState, useEffect } from 'react'
import ExcelJS from 'exceljs'

const Cods = (props) => {
    const [empresa, setEmpresa] = useState('')
    const [cod, setCod] = useState('')
    const [cant, setCant] = useState(0)
    const [modo, setModo] = useState('Agregar')
    const [codigos, setCodigos] = useState([])
    const [elegido, setElegido] = useState({ id: 0 })
    const [recargar, setRecargar] = useState(0)
    const [puedeBorrar, setPuedeBorrar] = useState(false)

    useEffect(() => {
        if (props.evento.con_cod) {
            const data = {
                method: 'GET',
                headers: {
                    'Authorization': 'Bearer ' + props.token,
                    'Content-Type': 'application/json'
                }
            }
            fetch(props.back + 'admin/traer_codigos/' + props.evento.tabla_cods, data)
                .then(response => response.json())
                .then(json => {
                    setCodigos(json.data)
                })
        }
    }, [props.evento, recargar, props.back, props.token])

    const f_selected = 'grid grid-cols-5 gap-2 items-center text-sm bg-white text-red-600'
    const f_no = 'grid grid-cols-5 gap-2 items-center text-sm bg-white'

    const mostrar = () => {
        return codigos.map(a => {
            return (
                <div className={a.id === elegido.id ? f_selected : f_no} onClick={e => elegir(a)}>
                    <label className='col-span-2 justify-self-start px-2'>{a.empresa}</label>
                    <label className='justify-self-start px-2'>{a.codigo}</label>
                    <label className='justify-self-end px-2'>{a.total}</label>
                    <label className='justify-self-end px-2'>{a.usado}</label>
                </div>
            )
        })
    }

    const elegir = (a) => {
        setElegido(a.id === elegido.id ? { id: 0 } : a)
        setCod(a.id === elegido.id ? '' : a.codigo)
        setEmpresa(a.id === elegido.id ? '' : a.empresa)
        setCant(a.id === elegido.id ? '' : a.total)
        setModo(a.id === elegido.id ? 'Agregar' : 'Editar')
        setPuedeBorrar(parseInt(a.usado) ? false : true)
    }

    const eliminar = () => {
        const data = {
            method: 'POST',
            body: JSON.stringify({ id: elegido.id, tabla: props.evento.tabla_cods }),
            headers: {
                'Authorization': 'Bearer ' + props.token,
                'Content-Type': 'application/json'
            }
        }
        fetch(props.back + 'admin/eliminar_codigo', data)
            .then(response => response.json())
            .then(json => {
                setElegido({ id: 0 })
                setCod('')
                setEmpresa('')
                setCant('')
                setModo('Agregar')
                setRecargar(recargar + 1)
            })
    }

    const guardar = () => {

        if (isNaN(cant)) {
            alert('la cantidad debe ser un número')
            return
        }
        if (!cod.length) {
            alert('Debe dar un código único')
            return
        }
        if (!elegido.id && codigos.find(a => a.codigo === cod.trim().toUpperCase()) !== undefined) {
            alert('Código ya existe')
            return
        }

        const data = {
            empresa: empresa,
            total: parseInt(cant),
            tabla: props.evento.tabla_cods,
            id: elegido.id,
            usado: !puedeBorrar,
            tabla_e: props.evento.tabla,
            codigo: !elegido.id ? cod.toLowerCase() : elegido.codigo.toLowerCase()
        }
        const subir = {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + props.token,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        }
        fetch(props.back + 'admin/guardar_codigo', subir)
            .then(response => response.json())
            .then(json => {
                console.log(json)
                setCod('')
                setCant(0)
                setEmpresa('')
                setRecargar(recargar + 1)
                elegir({ id: 0 })
            })
    }

    async function descargarConFormato() {
        const nuevo = codigos.map(e => {
            const { id, ...resto } = e
            return Object.keys(resto).reduce((acc, clave) => {
                typeof resto[clave] === 'string' ? acc[clave] = resto[clave].trim() : acc[clave] = resto[clave]
                return acc
            }, {})
        })

        const workbook = new ExcelJS.Workbook()
        workbook.creator = 'Sistema de Inscripciones'
        workbook.lastModifiedBy = 'Admin'
        workbook.created = new Date()
        workbook.modified = new Date()

        const worksheet = workbook.addWorksheet('Converge 2026', {
            properties: { tabColor: { argb: 'FF4472C4' } },
            pageSetup: { paperSize: 9, orientation: 'landscape' }
        })

        // Configurar columnas
        const columns = Object.keys(nuevo[0] || {})
        worksheet.columns = columns.map(col => ({
            header: col.charAt(0).toUpperCase() + col.slice(1),
            key: col,
            width: calcularAnchoColumna(nuevo, col)
        }))

        worksheet.views = [
            { state: 'frozen', xSplit: 0, ySplit: 1, activeCell: 'A2' }
        ]

        // Estilo para cabeceras
        worksheet.getRow(1).font = { bold: true, size: 12, color: { argb: 'FFFFFFFF' } }
        worksheet.getRow(1).fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'FF4472C4' }
        }
        worksheet.getRow(1).alignment = { horizontal: 'center', vertical: 'middle' }

        // Agregar datos
        worksheet.addRows(nuevo)

        // Estilo para filas alternadas (zebra striping)
        worksheet.eachRow((row, rowNumber) => {
            if (rowNumber > 1) {
                // Fondo alternado
                if (rowNumber % 2 === 0) {
                    row.fill = {
                        type: 'pattern',
                        pattern: 'solid',
                        fgColor: { argb: 'FFF2F2F2' } // Gris claro
                    }
                }

                // Bordes para todas las celdas
                row.eachCell(cell => {
                    cell.border = {
                        top: { style: 'thin' },
                        bottom: { style: 'thin' },
                        left: { style: 'thin' },
                        right: { style: 'thin' }
                    }
                })
            }
        })

        // Auto-filtro en la primera fila
        worksheet.autoFilter = {
            from: { row: 1, column: 1 },
            to: { row: 1, column: 2 }
        }

        // Generar archivo
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        })

        const fecha = new Date()
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = `listado_codigos ${fecha.toISOString().slice(0, 19).replace(/:/g, '-')}.xlsx`
        link.click()
        URL.revokeObjectURL(link.href)
    }

    function calcularAnchoColumna(data, columnName) {
        // Longitud del encabezado
        let maxLength = columnName.length

        // Revisar todas las filas
        data.forEach(row => {
            const value = row[columnName]
            if (value) {
                const length = value.toString().length
                if (length > maxLength) {
                    maxLength = length
                }
            }
        })

        // Añadir margen y limitar ancho máximo
        return Math.min(maxLength + 2, 50) // Máximo 50 caracteres
    }

    return (<>
        <div className='grid grid-cols-2 my-2 text-sm' style={{ height: 'calc(100vh - 200px)' }}>
            <div className='flex px-2 flex-col w-full overflow-x-hidden h-full'>
                <div className='grid grid-cols-5 gap-2 border-b-2 border-2 border-zinc-800 items-center text-sm flex-shrink-0'>
                    <label className='col-span-2 justify-self-start px-2'>Empresa</label>
                    <label className='justify-self-start px-2'>Código</label>
                    <label className='justify-self-end px-2'>Máximo</label>
                    <label className='justify-self-end px-2'>Usados</label>
                </div>
                <div className='overflow-y-auto flex-1 min-h-0 w-full text-sm'>
                    {mostrar()}
                </div>
                <div className='w-full mt-3 flex justify-center flex-shrink-0'>
                    <button
                        onClick={e => descargarConFormato()}
                        className='w-32 p-3 rounded-xl bg-green-500 text-white hover:bg-green-600 transition-colors'
                    >
                        Descargar
                    </button>
                </div>
            </div>

            <div className='bg-gray-300 flex flex-col justify-start text-lg px-2 w-1/2'>
                <div className='grid grid-cols-2 gap-4 my-2'>
                    <label className='w-64 my-2 px-2 text-red-600'>{modo}</label>
                    <button
                        className='bg-white text-blue-800 p-2 hover:text-white hover:bg-blue-800'
                        onClick={e => guardar()}
                    >
                        Guardar
                    </button>
                </div>
                <div className='grid grid-cols-2 gap-2 my-2'>
                    <label className='px-2 justify-self-start'>Empresa</label>
                    <input
                        type='text'
                        className='px-2 justify-self-end w-40 bg-white outline-0'
                        value={empresa}
                        onChange={e => setEmpresa(e.target.value)}
                    />
                </div>
                <div className='grid grid-cols-2 gap-2 my-2'>
                    <label className='px-2 justify-self-start'>Código</label>
                    <input
                        type='text'
                        className='px-2 justify-self-end w-40 bg-white outline-0'
                        value={cod}
                        onChange={e => setCod(e.target.value)}
                    />
                </div>
                <div className='grid grid-cols-2 gap-4 my-2'>
                    <label className='px-2 justify-self-start'>Cantidad</label>
                    <input
                        type='text'
                        className='px-2 justify-self-end w-40 bg-white outline-0 text-end'
                        value={cant}
                        onChange={e => setCant(parseInt(e.target.value))}
                    />
                </div>
                <div className='flex flex.row mx-10 justify-center mt-2'>
                    <button
                        className='w-32 p-2 text-white bg-red-400 hover:bg-red-800 rounded-xl disabled:bg-zinc-500'
                        disabled={!puedeBorrar}
                        onClick={e => eliminar()}
                    >
                        Eliminar
                    </button>
                </div>
            </div>

        </div>
    </>)
}

export default Cods
